// extracted by mini-css-extract-plugin
module.exports = {"feather":"title-box-module--feather--2PIua","titleBox":"title-box-module--title-box--SmASp"};